import { inject, Injectable } from '@angular/core';

import { BRAND, ORG_GUID, TellentBrand } from '@core/tellent-types';
import { injectTellentAppUrlOpener } from '@core/tellent-util';

import { TellentNavigationRoutingService } from '../navigation/navigation-routing.service';

@Injectable()
export class TellentManageRedirectService {
  private readonly tellentAppUrlOpener = injectTellentAppUrlOpener();
  private readonly tellentRoutingSvc = inject(TellentNavigationRoutingService);
  private readonly orgGuid = inject(ORG_GUID);
  private readonly brand = inject(BRAND);

  public sendMembersForPreonboarding(memberGuids: string[]): void {
    if (memberGuids.length > 1) {
      // Send members for bulk journeys creation
      this.tellentRoutingSvc.navigateById({
        appKind: 'core_hr',
        id: 'journeys:create_bulk',
        params: { tellentMemberGuids: memberGuids },
        orgGuid: this.orgGuid!,
      });
    } else {
      // Send single member for journey creation
      this.tellentRoutingSvc.navigateById({
        appKind: 'core_hr',
        id: 'journeys:create',
        params: { tellentMemberGuid: memberGuids[0] },
        orgGuid: this.orgGuid!,
      });
    }
  }

  public fillOutEmployeeProfiles(memberGuids: string[]): void {
    switch (this.brand) {
      case TellentBrand.Tellent:
        this.openMultipleProfiles(memberGuids);
        break;
      case TellentBrand.Kiwi:
        if (memberGuids.length === 1) {
          this.navigateToProfile(memberGuids[0]);
        } else {
          this.openMultipleProfiles(memberGuids);
        }
        break;
      default:
        break;
    }
  }

  public openEmployeeProfile(memberGuid: string): void {
    this.tellentAppUrlOpener(
      'core_hr',
      {
        id: 'profile:details',
        params: {
          tellentMemberGuids: memberGuid,
          showNewUserModal: false,
          page: 'employee-profile',
        },
      },
      this.orgGuid!,
      '_blank',
    );
  }

  private openMultipleProfiles(memberGuids: string[]): void {
    memberGuids.forEach(guid => {
      this.tellentAppUrlOpener(
        'core_hr',
        {
          id: 'profile:details',
          params: {
            tellentMemberGuids: guid,
            showNewUserModal: true,
            page: 'employee-profile',
          },
        },
        this.orgGuid!,
        '_blank',
      );
    });
  }

  private navigateToProfile(memberGuid: string): void {
    this.tellentRoutingSvc.navigateById({
      appKind: 'core_hr',
      id: 'profile:details',
      params: {
        tellentMemberGuids: memberGuid,
        showNewUserModal: 'true',
        page: 'employee-profile',
      },
      orgGuid: this.orgGuid!,
    });
  }
}
